export default __webpack_public_path__ + "static/media/brand3.8f18bb29.svg";